import React, { useId } from 'react';

import { Flexbox } from '../../Flexbox';
import { Text } from '../../Text';

import { InputAutocomplete } from '../shared';

import { TextArea, TextAreaWrapper, StyledLabel } from './style';

interface TextAreaInputProps {
  label: string;
  placeholder?: string;
  value?: string;
  autoComplete?: InputAutocomplete;
  minLength?: number;
  maxLength: number;
  required?: boolean;
  handleOnChange?: (event: React.ChangeEvent, value: string) => void;
}

export function TextAreaInput({
  label,
  placeholder,
  autoComplete,
  minLength = 1,
  maxLength = 140,
  required = false,
  value,
  handleOnChange
}: TextAreaInputProps) {
  const inputId = useId();
  const charsRemaining = maxLength - [...(value ?? '')].length;

  return (
    <Flexbox flexDirection="column">
      <TextAreaWrapper>
        <StyledLabel htmlFor={inputId}>
          {label}
          {required ? '*' : ''}
        </StyledLabel>
        <TextArea
          data-testid="text-area-input"
          id={inputId}
          required={required}
          placeholder={placeholder ?? ''}
          autoComplete={autoComplete ?? 'off'}
          minLength={minLength}
          maxLength={maxLength}
          onChange={(e) => {
            if (handleOnChange) handleOnChange(e, e.target.value);
          }}
          value={value}
          aria-required={required}
        />
      </TextAreaWrapper>
      <Text
        as="p"
        fontSize="s"
        lineHeight="smm"
        textAlign="right"
        padding={{ 0: ['sm', 's'] }}
      >{`${charsRemaining} characters remaining`}</Text>
    </Flexbox>
  );
}
